/**
 * Detects if you're on server side or not by using the `typeof window === 'undefined'`.
 */
const isServerSide = () => typeof window === 'undefined';

export { isServerSide };
